<template>
	<div>
		<o-skeleton width="4em" v-if="loading"></o-skeleton>
		<span v-else>
			{{ v }}
		</span>
	</div>
</template>
<script>
	// For conversions to be accurate, a USD amount should be used. Otherwise you should use 'static: true'
	import { ref, inject, computed, watch, onMounted } from "vue";
	import { useRoute } from "vue-router";
	import numberFormat from "@/services/utils/currencyFormat";
	export default {
		props: {
			amount: {
				type: [String, Number],
				default: null
			},
			currency: {
				type: String,
				default: "USD"
			},
			static: {
				type: Boolean,
				default: false
			}
		},
		setup(props, context) {
			const $http = inject("$http");

			const loading = ref(true);
			const rate = ref(1);

			const GetExchangeRate = async (currency) => {
				if (!props.static) {
					loading.value = true;
					try {
						//DO WE NEED TO MAKE A EXCHAGE RATE CALL EVERYTIME WE FORMAT?
						//const resp = await $http.get("/api/v2/exchangeRate/" + currency);
						//rate.value = resp.data;
					} catch (err) {
						console.error(err);
					}
					loading.value = false;
				} else {
					loading.value = false;
				}
			};

			const v = computed(() => {
				return numberFormat.format(props.amount / rate.value, props.currency);
			});

			watch(
				() => props.currency,
				(n) => {
					GetExchangeRate(n);
				}
			);

			onMounted(() => {
				GetExchangeRate(props.currency);
			});

			return {
				loading,
				rate,
				v
			};
		}
	};
</script>
